<template>
  <div>
    <fieldset class="lib__form__fieldset">
      <legend class="lib__form__legend">{{ $t('workFileTracking.tracking.addressAndContact') }}</legend>

      <InfoTable>
        <InfoTableItem>
          <template v-slot:icon><i class="lib__infotable__icon fas fa-folder"></i></template>
          <template v-slot:label>{{ $t('workFileTracking.tracking.workFileNumber') }} : </template>
          <template v-slot:value>{{ reference }}</template>
        </InfoTableItem>
        <InfoTableItem>
          <template v-slot:icon><i class="lib__infotable__icon fas fa-calendar"></i></template>
          <template v-slot:label>{{ $t('workFileTracking.tracking.requestDate') }} : </template>
          <template v-slot:value>{{ startDate }}</template>
        </InfoTableItem>
        <InfoTableItem>
          <template v-slot:icon><i class="lib__infotable__icon fas fa-home"></i></template>
          <template v-slot:label>{{ $t('workFileTracking.tracking.workAddress') }} : </template>
          <template v-slot:value>{{ workAddress }}</template>
        </InfoTableItem>
        <InfoTableItem v-if="false"> <!-- Masquer pour l'instant -->
          <template v-slot:icon><i class="lib__infotable__icon fas fa-address-card"></i></template>
          <template v-slot:label>{{ $t('workFileTracking.tracking.contact') }} : </template>
          <template v-slot:value v-if="workFile.contactInfo">
            <span>{{ workFile.contactInfo.name }}</span>
            <br />
            <span v-if="workFile.contactInfo.mobilePhoneNumber"> {{ workFile.contactInfo.mobilePhoneNumber }} </span>
            <span v-if="workFile.contactInfo.mobilePhoneNumber && (workFile.contactInfo.housePhoneNumber || workFile.contactInfo.email)"> - </span>
            <span v-if="workFile.contactInfo.housePhoneNumber"> {{ workFile.contactInfo.housePhoneNumber }} </span>
            <span v-if="workFile.contactInfo.email && (workFile.contactInfo.mobilePhoneNumber || workFile.contactInfo.housePhoneNumber)"> - </span>
            <span v-if="workFile.contactInfo.email"> {{ workFile.contactInfo.email }}</span>
          </template>
          <template v-slot:value v-else>
            <span>{{ $t('workFileTracking.tracking.contactAvailableIn24Hours') }}</span>
          </template>
        </InfoTableItem>
        <InfoTableItem v-if="workFile.workRequests[0].offerType !== 'verbalOffer'">
          <template v-slot:icon><i class="lib__infotable__icon fas fa-question-circle"></i></template>
          <template v-slot:label>{{ $t('workFileTracking.tracking.advisor') }} : </template>
          <template v-slot:value><span v-html="advisor"></span></template>
        </InfoTableItem>
      </InfoTable>
    </fieldset>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import { WorkFile } from '@/models'
import { dateService } from '@ores/vue-library'

@Component({
  name: 'work-file-address-and-contact'
})
export default class WorkFileAddressAndContact extends Vue {
  //#region [Property]
  @Prop({ type: Object, required: true }) public readonly workFile!: WorkFile
  //#endregion

  //#region [Computed]
  public get reference() {
    return this.workFile.reference.replace(/^0+/, '')
  }

  public get startDate() {
    return dateService.displayDateText(this.workFile.startDate!)
  }

  public get workAddress() {
    const address = this.workFile.workExecutionAddress
    return `${address.houseNumber}
            ${address.streetName}${address.complement ? ' ' + address.complement : ''} -
            ${address.zipCode} ${address.cityName}`
  }

  public get advisor() {
    if (this.workFile.customerAdvisor) {
      return `${this.workFile.customerAdvisor.name} - ${this.workFile.customerAdvisor.publicNumber ? this.workFile.customerAdvisor.publicNumber : '078/15.78.01'}`
    }
    return `078/15.78.01 - <a href="mailto:contact@ores.be">contact@ores.be</a>`
  }
  //#endregion
}
</script>